import {
  ID_ADD, TOKEN_ADD, PROJECT_ADD,
  NEW_FILE, MAX_FILE, APP_ACTIVE,
  SHOW_APP, LOGIN_APP, ADD_ALIVE,
  KEEP_FALSE, NEW_PKG, DONE_PKG,
  ADD_SCROLL, ALERT_WARN, SHOW_TRANSFER,
  SET_INFO, SENT_FILE, ACTIVE_ALIVE,
  ROLE_ADD, SHOW_LANG, ADD_SIZE,
  SHOW_DOWN,
  USER_ADD, SPACE_ADD, OTHER_SHOW,
  SPACELIST_SHOW, LEFT_SHOW, BOX_SHOW,
  EL_UPDATE, VER_CHECK, SHOW_KICK,
  SHOW_MSG, SHOW_FLOATING, EL_TRANSFER,
  SHOW_DOWNMSG, PERMISSION_ADD,
} from './types'
const actions = {
  addId: ({ commit }, id) => commit(ID_ADD, id),
  addToken: ({ commit }, token) => commit(TOKEN_ADD, token),
  addRole: ({ commit }, role) => commit(ROLE_ADD, role),
  addProject: ({ commit }, id) => commit(PROJECT_ADD, id),
  newFile: ({ commit }, el) => commit(NEW_FILE, el),
  maxFile: ({ commit }, el) => commit(MAX_FILE, el),
  activeApp: ({ commit }, el) => commit(APP_ACTIVE, el),
  showApp: ({ commit }, el) => commit(SHOW_APP, el),
  showTransfer: ({ commit }, el) => commit(SHOW_TRANSFER, el),
  loginApp: ({ commit }, el) => commit(LOGIN_APP, el),
  addAlive: ({ commit }, el) => commit(ADD_ALIVE, el),
  clearKeep: ({ commit }, el) => commit(KEEP_FALSE, el),
  newPkg: ({ commit }, el) => commit(NEW_PKG, el),
  donePkg: ({ commit }, el) => commit(DONE_PKG, el),
  addScroll: ({ commit }, el) => commit(ADD_SCROLL, el),
  alertWarn: ({ commit }, el) => commit(ALERT_WARN, el),
  setInfo: ({ commit }, el) => commit(SET_INFO, el),
  sentFile: ({ commit }, el) => commit(SENT_FILE, el),
  activeAlive: ({ commit }, el) => commit(ACTIVE_ALIVE, el),
  showLang: ({ commit }, el) => commit(SHOW_LANG, el),
  addSize: ({ commit }, el) => commit(ADD_SIZE, el),
  showDown: ({ commit }, el) => commit(SHOW_DOWN, el),
  // passDown: ({commit}, el) => commit(PASS_DOWN, el),
  //
  addUser: ({ commit }, data) => commit(USER_ADD, data),
  addSpace: ({ commit }, data) => commit(SPACE_ADD, data),
  addPermission: ({ commit }, data) => commit(PERMISSION_ADD, data),
  showOther: ({ commit }, data) => commit(OTHER_SHOW, data),
  showSpacelist: ({ commit }, data) => commit(SPACELIST_SHOW, data),
  showLeft: ({ commit }, data) => commit(LEFT_SHOW, data),
  showBox: ({ commit }, data) => commit(BOX_SHOW, data),
  updateEl: ({ commit }, data) => commit(EL_UPDATE, data),
  checkVer: ({ commit }, data) => commit(VER_CHECK, data),
  showKick: ({ commit }, data) => commit(SHOW_KICK, data),
  showMsg: ({ commit }, data) => commit(SHOW_MSG, data),
  showFloating: ({ commit }, data) => commit(SHOW_FLOATING, data),
  transferEl: ({ commit }, data) => commit(EL_TRANSFER, data),
  downloadMsg: ({ commit }, data) => commit(SHOW_DOWNMSG, data)
}
export default actions
